import { requestApi } from '../util/network'
import axios from 'axios'  // 添加这行导入语句
//获取兑换代金券数据
export const qyh5api =
    (token) =>
        requestApi(
            '/Jzuniqy/qyh5api',
            'POST',
            {
                'token': token,
            }
        )
export const qytestdhdd = async (token) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: { token: token },
            url: env.API_HOST + "/Jzuniqy/qytestdhdd"
        });
        //console.log("API响应:", res);
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
export const qytestdh = async (token,template_id) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: { token: token,template_id:template_id},
            url: env.API_HOST + "/Jzuniqy/qytestdh"
        });
        //console.log("API响应:", res);
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
export const qytestdhyy = async (token,vid) => {
    try {
        const res = await axios({
            headers: {},
            method: 'POST',
            data: { token: token,vid:vid},
            url: env.API_HOST + "/Jzuniqy/qytestdhyy"
        });
        //console.log("API响应:", res);
        return res;
    } catch (error) {
        console.log("API请求错误:", error);
        return { code: 500, info: "请求失败", error: error.message };
    }
};
